import { type Meta } from '../types/docs';

const META: Meta = {
  name: 'copied_transcript_segment',
  description: 'Called when user clicks "Copy Transcript" button',
  params: [
    {
      name: 'clip_id',
      description: 'The ID of clip',
      required: true,
      type: 'string',
    },
    {
      name: 'start_time_ms',
      description: 'The start time of the segment in milliseconds',
      required: true,
      type: 'number',
    },
    {
      name: 'end_time_ms',
      description: 'The end time of the segment in milliseconds',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
